import { Component, Input } from '@angular/core';

@Component({
  selector: 'pty-customer-payment-info',
  templateUrl: './customer-payment-info.component.html',
  styleUrls: ['./customer-payment-info.component.scss']
})
export class CustomerPaymentInfoComponent {
  @Input() partyId:string;
  /**
   * CustomerCreditCardPaymentMethods
   * ListCustomerBillingAccounts
   * CustomerCheckingPaymentMethods
   * CustomerCompanyCheckAccounts
   * CustomerPersonalCheckAccounts
   * CustomerEftPaymentMethods
   */
}
